// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"895da10c","805":"34c50146","870":"1f38a13a","896":"863d9580"}[chunkId] + ".chunk.js";
};